(function() {
  angular
    .module('avisos', ['aol.service']);
})();
